<template>
  <div v-if="!thinking">
    <div
      v-if="responseResult"
      class="text-center text-green-500 flex flex-col items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-16 w-16 mb-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
        />
      </svg>
      <h3>Success!</h3>
    </div>
    <div
      v-else
      class="text-center text-red-500 flex flex-col items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-16 w-16 mb-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z"
        />
      </svg>
      <h3>Uh oh...</h3>
    </div>

    <p class="text-center mt-6">{{ response }}</p>
  </div>
</template>

<script>
import { EventBus } from '../../../../js/plugins/event-bus.js'

export default {
  props: {
    token: { default: false },
    subscribe: { default: 'newsletter-subscribe' },
  },

  data() {
    return {
      thinking: true,
      response: 'Nothing to show...',
      responseResult: false,
    }
  },

  mounted() {
    if (this.token) {
      let endpoint = false
      if (this.subscribe === 'newsletter-subscribe') {
        endpoint = 'validate-subscription'
      }
      if (this.subscribe === 'newsletter-unsubscribe') {
        endpoint = 'unsubscribe'
      }

      if (!endpoint) {
        EventBus.$emit('showModal', false)
        return
      } else {
        axios
          .post('/api/' + endpoint, { token: this.token })
          .then((response) => {
            let returned = response.data
            this.$set(this, 'thinking', false)

            if (returned.success) {
              let message = ''
              if (endpoint === 'validate-subscription') {
                message = 'Your subscription has been activated.'
              }
              if (endpoint === 'unsubscribe') {
                message =
                  'Your email has successfully been removed from our newsletter.'
              }

              this.$set(this, 'response', message)
              this.$set(this, 'responseResult', true)
            } else {
              if (response.data.alert) {
                EventBus.$emit('triggerAlertResponse', response.data.alert)
              }

              // response.data.alert ? this.$set(this,'response',response.data.alert.message) : this.$set(this,'response','Something went wrong.');
            }
          })
      }
    } else {
      // EventBus.$emit('showModal',false);
      // EventBus.$emit('triggerAlertResponse',{ status : 'error', 'message' : 'Error'});
    }
  },
}
</script>
